export default __webpack_public_path__ + "static/media/arrow-up.98be78b4.svg";